import * as Yup from "yup";
import { Formik } from "formik";
import {
  /* Alert, */ Box,
  Button,
  FormHelperText,
  TextField,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import useAuth from "../../../hooks/useAuth";
import useMounted from "../../../hooks/useMounted";
import { useState } from "react";
import PropTypes from "prop-types";

function LoginJWT(props) {
  const mounted = useMounted();
  const { login } = useAuth();
  const { onMFARequired } = props;
  const [open, setOpen] = useState(false);

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        submit: null,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        password: Yup.string().max(255).required("Password is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        if (mounted.current) {
          setOpen(true);
        }
        try {
          const result = await login(values.email, values.password);

          if (result && result.mfaRequired) {
            if (typeof onMFARequired === "function") {
              onMFARequired(values.email);
            }
            if (mounted.current) {
              setStatus({ success: true });
              setSubmitting(false);
              setOpen(false);
            }
            return;
          }

          if (mounted.current) {
            setStatus({ success: true });
            setSubmitting(false);
            setOpen(false);
          }
        } catch (err) {
          console.error(err);
          if (mounted.current) {
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
            setOpen(false);
          }
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit} {...props}>
          <TextField
            autoFocus
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            label="Email Address"
            margin="normal"
            name="email"
            onBlur={handleBlur}
            onChange={handleChange}
            type="email"
            value={values.email}
            variant="outlined"
          />
          <TextField
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            label="Password"
            margin="normal"
            name="password"
            onBlur={handleBlur}
            onChange={handleChange}
            type="password"
            value={values.password}
            variant="outlined"
          />
          {errors.submit && (
            <Box sx={{ mt: 3 }}>
              <FormHelperText error>{errors.submit}</FormHelperText>
            </Box>
          )}
          <Box sx={{ mt: 2 }}>
            <Button
              color="primary"
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              Log In
            </Button>
            <Backdrop
              sx={{
                color: "#5271ff",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={open}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </Box>
          {/* <Box sx={{ mt: 2 }}>
            <Alert severity="info">
              <div>
                Use
                {' '}
                <b>demo@devias.io</b>
                {' '}
                and password
                {' '}
                <b>Password123!</b>
              </div>
            </Alert>
          </Box> */}
        </form>
      )}
    </Formik>
  );
}

export default LoginJWT;

LoginJWT.propTypes = {
  onMFARequired: PropTypes.func,
};
